import hash from 'object-hash';

class CacheService {
    localCache = {};
    getHash (...properties) {
        return hash({ ...properties });
    }

    getCache (key) {
        return this.localCache[key];
    }

    setCache (key, value) {
        this.localCache[key] = value;
    }

    hasKey (key) {
        return key in this.localCache;
    }
};

export const cacheService = new CacheService();
